import * as S from './Card.styles'

const Card = ({ children }) => {
  return (
    <S.Wrapper>
      {children}
    </S.Wrapper>
  )
}

export default Card
